import React, { Component } from "react";
import $ from 'jquery'
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'
import { connect } from "react-redux";
import 'react-quill/dist/quill.snow.css';
import Swal from "sweetalert2";
import Select from "react-select";
import { GET_CATEGORY_QUOTE, GET_QUOTES, addApp, updateApp } from '../../../../../../../actions/sceneActions'
import './motivationalQuote/quote.css'
import { getWallID,customClass, stripTrailingSlash, getInitialRoute} from '../../../../../../../utils'
import {
    Card,
    Button,
    Row,
    Col,
    Form,
} from "react-bootstrap";
import { DISPLAY_APPS_SUCCESS_SAVE, SUCCESS_TEXT } from "../../messageText";
import { NavigationHeader } from "../../../_metronic/layout/components/navigationheader/NavigationHeader";
import MotivationalQuotePreview from "../../../_metronic/_partials/apps/motivationalQuotes";

const timeIntervalOption = [
    { value: 0.166667, label: "10 Sec" },
    { value: 0.5, label: "30 Sec" },
    { value: 1, label: "1 Min" },
    { value: 3, label: "3 Min" },
    { value: 5, label: "5 Min" }
];

class MotivationalQuote extends Component {
    state = {
        wallID: getWallID(), error: null, categoryItem: [], quotesData: "", categoryValue: "inspirational", quoteCompleteData: [],
        animationStyle: 'toggleIn',
        animationStyleNew: 'zoomScale',
        updateApi: false,
        timeInterval: null,
        buttonDis: false,
        loader: false,
        stateChanged: false,
    }
    componentWillMount() {
        this.props.GET_CATEGORY_QUOTE()
    }
    componentDidMount() {
        const { scenes, location } = this.props;
        this.changelCategoryUpdate({ value: "inspirational" });
        const { app_data } = scenes.updateSceneData;
        if (app_data  && location.pathname.includes('update')) {
            const { categoryItem, quotesData, categoryValue, timeInterval } = app_data;
            this.changelCategoryUpdate({ value: app_data.categoryValue });
            if (quotesData) this.setState({
                categoryItem, quotesData, categoryValue, timeInterval, updateApi: true
            }, () => this.onUpdateFontSize());
        }
        else this.onGetCategoryUpdate("inspirational")
        window.addEventListener("resize", () => {
            this.autoSizeText();
        });

    }
    changelCategoryUpdate = (event) => this.onGetCategoryUpdate(event.value)
    onGetCategoryUpdate = (name) => {
        this.setState({ categoryValue: name }, () => {
            GET_QUOTES(name).then((response) => {
                const { responseData, responseCode } = response.data;
                if (responseCode == 200) {
                    let currentIndex = 0;
                    this.setState({ animationStyle: 'toggleIn', animationStyleNew: 'zoomScale', quoteCompleteData: responseData, quotesData: responseData[currentIndex], currentIndex }, () => this.onUpdateFontSize())
                }
            })
        })
    }

    changeTimeIntervalUpdate = (event) => {
        this.setState({ timeInterval: event.value }, () => this.onUpdateQuotes());
    };
    onUpdateQuotes = () => {
        const { timeInterval, currentIndex, quoteCompleteData } = this.state;
        if (timeInterval && timeInterval > 0) {

            this.setState({ stateChanged :true })
            const currentTimeInterval = parseInt(timeInterval * 60 * 1000);
            if (this.timeUpdateInterval && this.timeUpdateInterval != undefined) clearInterval(this.timeUpdateInterval)
            this.timeUpdateInterval = setInterval(() => {
                if (quoteCompleteData.length < currentIndex) {
                    this.setState({ animationStyle: 'toggleOut' }, () => setTimeout(() => this.setState({ animationStyle: 'toggleIn', quotesData: quoteCompleteData[0], currentIndex: 0 }, () => this.onUpdateFontSize()), 300));
                    this.setState({ animationStyleNew: 'toggleOut' }, () => setTimeout(() => this.setState({ animationStyle: 'zoomScale', quotesData: quoteCompleteData[0], currentIndex: 0 }, () => this.onUpdateFontSize()), 300))
                }
                else {
                    const updateCurrentIndex = this.state.currentIndex + 1;
                    this.setState({ animationStyle: 'toggleOut' }, () => setTimeout(() => this.setState({ animationStyle: 'toggleIn', quotesData: quoteCompleteData[updateCurrentIndex], currentIndex: updateCurrentIndex }, () => this.onUpdateFontSize()), 300))
                    this.setState({ animationStyleNew: 'toggleOut' }, () => setTimeout(() => this.setState({ animationStyleNew: 'zoomScale', quotesData: quoteCompleteData[updateCurrentIndex], currentIndex: updateCurrentIndex }, () => this.onUpdateFontSize()), 300))
                }
            }, currentTimeInterval);
        }
    }
    onUpdateFontSize = () => {
        this.autoSizeText();
    }
    onTimerSave = (event) => { 
        const { param } = this.props;
        const { categoryItem, quotesData, categoryValue, timeInterval } = this.state;
        if (timeInterval && categoryValue && categoryValue != "" && categoryValue.length > 0) {

            this.setState({buttonDis:true,loader:true})
            this.state.updateApi
                ? this.props.updateApp(
                    param.contentMixId,
                    this.props.scenes.updateSceneData.id,
                    { categoryItem, quotesData, categoryValue, timeInterval },
                    8,
                    this.onSaveCallBack
                )
                : this.props.addApp(
                    param.contentMixId,
                    param.positionID,
                    { categoryItem, quotesData, categoryValue, timeInterval },
                    "Motivational Quote",
                    8,
                    this.onSaveCallBack
                );
        }

        else if (timeInterval == null || timeInterval.length == 0) {
            Swal.fire({
                title: 'Error',
                text: 'Please set the time interval !',
                type: "error",
                icon: 'error',
                showConfirmButton: false,
                timer: 3000
            })
        }
        else if (categoryValue == null || categoryValue.length == 0) {
            Swal.fire({
                title: 'Error',
                text: 'Please set the category !',
                type: "error",
                icon: 'error',
                showConfirmButton: false,
                timer: 3000
            })
        }

        else {
            Swal.fire({
                title: 'Error',
                text: 'Please check all select!',
                type: "error",
                icon: 'error',
                showConfirmButton: false,
                timer: 3000
            })
        }
    };

    onBack = (event) => {
        const { params } = this.props.match;
        const { pathname } = this.props.location; 

         if (!this.state.stateChanged) {
            this.props.history(stripTrailingSlash(pathname,params))
            return;
          }
        
        Swal.fire({
            title: "Are you sure?",
            text: "Your changes have not been saved. Do you want to save before you leave the page?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Save",
            cancelButtonText: "Discard Changes",
            reverseButtons: true,
            customClass: customClass

        }).then((result) => {
            if (result.value) {
                this.onTimerSave()
            } else if (result.dismiss === "cancel") {
                this.props.history(stripTrailingSlash(pathname,params))
            }
        });
    };

    onSaveCallBack = () => {
        const { params } = this.props.match;
        Swal.fire({
            title: SUCCESS_TEXT,
            text: DISPLAY_APPS_SUCCESS_SAVE,
            type: "success",
            icon: "success",
            showConfirmButton: false,
            timer: 3000,
        }).then((result) => {
            this.setState({buttonDis:false,loader:false})
            this.props.history(`/studio/${params.wallId}`);
        });
    };
    autoSizeText = () => {
        var el, elements, _i, _len, _results;
        $('.resize').removeAttr("style");
        elements = $('.resize');
        if (elements.length < 0) {
            return;
        }
        _results = [];
        for (_i = 0, _len = elements.length; _i < _len; _i++) {
            el = elements[_i];
            _results.push((function (el) {
                var resizeText, _results1;
                resizeText = function () {
                    var elNewFontSize;
                    elNewFontSize = (parseInt($(el).css('font-size').slice(0, -2)) - 1) + 'px';
                    return $(el).css('font-size', elNewFontSize);
                };
                _results1 = [];
                while (el.scrollHeight > el.offsetHeight) {
                    _results1.push(resizeText());
                }
                return _results1;
            })(el));
        }
        return _results;
    }

    render() {
        const { match, name } = this.props;
        const { categoryValue, timeInterval,buttonDis, loader } = this.state;
        const { categorydata } = this.props;
        const { pathname } = this.props.location; 
        return (

            <>
             <NavigationHeader
                name={name} 
                backToNavigation={`${pathname ? stripTrailingSlash(pathname,match) : ''}`}
              /> 
                <div className="container-fluid subheader_content">
                    <Card className="select_wall mb-3 rounded-0 border-0 custom-overlay-parent">
                        <Card.Body className="p-0">
                            <Row>
                                <Col lg={4} className="border-right-lg">
                                    <Card className="border-0 rounded-0">
                                        <Card.Body className="p-4 card_height">
                                            <Form>

                                                <Form.Group className="form-group" controlId="text-background">
                                                    <Form.Label>Select Category</Form.Label>
                                                    {categorydata && categorydata.length > 0 && <Select
                                                        value={categorydata.find(option => option.value === categoryValue)}
                                                        onChange={value => this.changelCategoryUpdate(value)}
                                                        options={categorydata}
                                                        defaultValue={{ value: "inspirational", label: "Inspirational" }}
                                                    />}
                                                </Form.Group>
                                                <Form.Group className="form-group" controlId="text-background">
                                                    <Form.Label>Set Time Interval</Form.Label>
                                                    <Select
                                                        value={timeIntervalOption.find(option => option.value === timeInterval)}
                                                        onChange={this.changeTimeIntervalUpdate}
                                                        options={timeIntervalOption}
                                                    />


                                                </Form.Group>
                                                {this.state.number}

                                            </Form>
                                        </Card.Body>
                                        <Card.Footer className="bg-transparent d-flex justify-content-end border-0 p-4">
                                            <button
                                                className="btn btn-outline-dark me-3 btn-min-w"
                                                onClick={this.onBack}
                                            >
                                                <span className="position-relative">Back</span>
                                            </button>
                                            <Button
                                                variant="primary"
                                                onClick={this.onTimerSave}
                                                disabled={ buttonDis } 
                                                className={`btn btn-primary btn-min-w ${loader ? `spinner spinner-white spinner-right disabled` : null}`}
                                                id="Studio_Quotes_App_Users"
                                            >
                                                Save
                                            </Button>
                                        </Card.Footer>
                                    </Card>
                                </Col>
                                <Col
                                    lg={8}
                                    className="d-flex align-items-center justify-content-center"
                                >
                                    <Card className="border-0 card w-100">
                                        <Card.Body className="border-0">
                                            <div className="wall_view">
                                                <div className="wall_view_wrapper">
                                                    <MotivationalQuotePreview {...this.state} onUpdateFontSize={this.onUpdateFontSize} />
                                                </div>
                                            </div>


                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </div>
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        categorydata: state.quote.categorydata,
        scenes: state.scene,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        GET_CATEGORY_QUOTE: () => dispatch(GET_CATEGORY_QUOTE()),
        addApp: (contentMixId, position, appContent, appName, appId, callBack) =>
            dispatch(
                addApp(contentMixId, position, appContent, appName, appId, callBack)
            ),
        updateApp: (contentMixId, sceneContentId, appContent, appId, callBack) =>
            dispatch(
                updateApp(contentMixId, sceneContentId, appContent, appId, callBack)
            ),
    }
}



export default connect(mapStateToProps, mapDispatchToProps)(MotivationalQuote);


